<template>
  <div class="card">
    <v-form>
      <div class="Login-title mb-2">
        <v-icon class="mr-1" @click="$router.push('/')"
          >mdi mdi-chevron-left</v-icon>
        Forgot your password?
      </div>

      <v-error class="pb-0" v-if="userNotFount">
        User not found in database
      </v-error>

      <div class="img-wrapper">
        <img
          :src="require('../assets/forgetPassword.gif')"
          alt="Forgot Password"
          style="height: 180px; width: 180px"
        />
      </div>

      <div class="text-wrapper pl-1">
        <p class="instructions">Please enter your registered Email ID.</p>
        <p class="instructions-text">
          We will send you a verification code to your below mentioned Email ID.
        </p>
      </div>

      <v-text-field
        v-model="email"
        type="email"
        placeholder="Your Email"
        prepend-inner-icon="mdi-email"
        variant="outlined"
        density="compact"
        @input="userNotFount = false"
        :rules="[rules.userRule, rules.emailValidation]"
        class="custom-text-field pl-1"
      />

     <div class="pl-1">
      <v-btn
        color="#1b1a47"
        block
        size="large"
        :loading="loading"
        class="log-btn text-white mt-3"
        @click="sendEmail"
      >
        Next
      </v-btn>
     </div>
    </v-form>
  </div>
</template>

<script>
import ResetPasswordService from "@/api/service/ResetPasswordService";
export default {
  data() {
    return {
      userNotFount: false,
      email: "",
      loading: false,
      showPassword: false,
      passwordRule: [(value) => !!value || "Password is Required."],
      password: null,
      host: "",
      rules: {
        emailValidation: (value) => !!value || "Email is Required.",
        useremail: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  methods: {
    async sendEmail() {
      try {
        this.loading = true;
        let data = {
          host: window.location.origin,
          email: this.email,
          appId: localStorage.getItem("APP_ID"),
          redirectUrl: localStorage.getItem("REDIRECT_URL"),
        };
        localStorage.setItem("PASSWORD_DATA", JSON.stringify(data));
        let response = await ResetPasswordService.forgotPassword(data);
        console.log(response, "hhhhhhhhh");
        if (response.message == "User not found in firebase") {
          this.userNotFount = true;
          this.loading = false;
        } else {
          this.$router.push({
            path: "/checkemail",
            query: { email: this.email, host: window.location.origin },
          });
        }
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
  },
};
</script>
<style scoped>
.forgot-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.forgot-card {
  max-width: 400px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.Login-title {
  font-size: 16px;
  font-weight: 500;
}

.img-wrapper {
  display: flex;
  justify-content: center;
  /* margin-bottom: 16px; */
}

.img-wrapper img {
  width: 100%;
  height: 150px;
  max-width: 200px;
}

.text-wrapper {
  margin-bottom: 16px;
}

.instructions {
  font-size: 13px;
  color: #565656;
  margin: 0;
}

.instructions-text {
  font-size: 11px;
  color: #686868;
  /* margin: 4px 0 0 0; */
}

.log-btn {
  font-weight: 600;
  border-radius: 4px;
  /* margin-top: 16px; */
}

.custom-text-field {
  margin-top: 12px;
}
>>>.v-field--error:not(.v-field--disabled) .v-field__prepend-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__clearable > .v-icon {
    color: #5e5f60 !important;
}
</style>
